export default {
  getUser: state => {
    return state.userInfo();
  },
  getLoginGroup: state => {
    return state.loginGroup;
  }
}